<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<h2 class="CH1_Chapter_title_1" id="_idParaDest-6"><span class="CharOverride-10">PART ONE</span></h2>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// RR0208-5.vue?27d16ba8